import { render, staticRenderFns } from "./FormLongtext.vue?vue&type=template&id=47afe0ac&scoped=true&"
import script from "./FormLongtext.vue?vue&type=script&lang=js&"
export * from "./FormLongtext.vue?vue&type=script&lang=js&"
import style0 from "./FormLongtext.vue?vue&type=style&index=0&id=47afe0ac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47afe0ac",
  null
  
)

export default component.exports